import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout';
import HomePage from '@/pages/Home/HomePage';
import AboutPage from '@/pages/About/AboutPage';
import ServicesPage from '@/pages/Services/ServicesPage';
import IndustriesPage from '@/pages/Industries/IndustriesPage';
import TechnologyPage from '@/pages/Technology/TechnologyPage';
import InsightsPage from '@/pages/Insights/InsightsPage';
import ContactPage from '@/pages/Contact/ContactPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicy/PrivacyPolicyPage';

const router = createBrowserRouter([
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage key="privacy-policy" />,
  },
  {
    path: '/terms-of-service',
    element: <PrivacyPolicyPage key="terms-of-service" title="Terms of Service" source="/terms-of-service.md" />,
  },
  {
    path: '/data-deletion',
    element: <PrivacyPolicyPage key="data-deletion" title="Data Deletion" source="/data-deletion.md" />,
  },
  {
    path: '/refund-policy',
    element: <PrivacyPolicyPage key="refund-policy" title="Refund and Cancellation Policy" source="/refund-policy.md" />,
  },
  {
    path: '/pricing',
    element: <PrivacyPolicyPage key="pricing" title="Services and Pricing" source="/pricing.md" />,
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: '/about',
        element: <AboutPage />,
      },
      {
        path: '/services',
        element: <ServicesPage />,
      },
      {
        path: '/industries',
        element: <IndustriesPage />,
      },
      {
        path: '/technology',
        element: <TechnologyPage />,
      },
      {
        path: '/insights',
        element: <InsightsPage />,
      },
      {
        path: '/contact',
        element: <ContactPage />,
      },
      {
        path: '*',
        element: <HomePage />,
      },
    ],
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}